'use client'

import { createRequiredContext } from 'design-system'
import { type ReactNode } from 'react'
import { type FetchLoggedInUserQuery } from '~gql-types/graphql'

export type User = FetchLoggedInUserQuery['loggedInUser']

const [useUserContext, UserContext] = createRequiredContext<User>('UserContext')

interface UserProviderProps {
  children: ReactNode
  user: User
}

const UserProvider = ({ children, user }: UserProviderProps) => {
  return <UserContext value={user}>{children}</UserContext>
}

export { UserProvider, useUserContext }
